import API from '@/api'
import axios from 'axios'
class ProductService {
  getList(params) {
    const response = axios.get(API.product_list, {
      headers: {
        'Accept-Language': 'es'
      },
      params: params
    })
    return response
  }

  getDetail(id, lang = 'es') {
    const response = axios.get(API.product_detail_update(id), {
      headers: {
        'Accept-Language': lang
      }
    })
    return response
  }

  putDetail(id, data, lang = 'es') {
    const response = axios.put(API.product_detail_update(id), data, {
      headers: {
        'Accept-Language': lang
      }
    })
    return response
  }

  deleteDetail(id) {
    const response = axios.delete(API.product_detail_update(id))
    return response
  }

  postNew(data) {
    const response = axios.post(API.product_create, data)
    return response
  }

  putImage(id, data) {
    const response = axios.put(API.product_update_image(id), data)
    return response
  }

  putPdf(id, data) {
    const response = axios.put(API.category_update_pdf(id), data)
    return response
  }

  getListCategory() {
    const response = axios.get(API.category_products_list, {
      headers: {
        'Accept-Language': 'es'
      }
    })
    return response
  }

  getListLocal() {
    const response = axios.get(API.company_locals_list)
    return response
  }

  getFormList(id) {
    const response = axios.get(API.product_form_list(id))
    return response
  }

  postFormList(id, data) {
    const response = axios.post(API.product_form_create(id), data)
    return response
  }

  getFormItem(params) {
    const response = axios.get(API.product_list_for_form_option, {
      params: {
        search: params.query,
        product_id: params.id
      }
    })
    return response
  }

  deleteForm(id, idForm) {
    const response = axios.delete(API.product_form_update(id, idForm))
    return response
  }

  putForm(id, idForm, params) {
    const response = axios.put(API.product_form_update(id, idForm), params)
    return response
  }

  postFormOption(id, data) {
    const response = axios.post(API.product_form_option_create(id), data)
    return response
  }

  getOptionItemList(params) {
    const response = axios.get(API.product_list_for_form_option, {
      params: {
        search: params.query,
        product_id: params.id
      }
    })
    return response
  }

  putOptionItem(id, params) {
    const response = axios.put(
      API.product_form_option_update_destroy(id),
      params
    )
    return response
  }

  deleteOptionItem(id) {
    const response = axios.delete(API.product_form_option_update_destroy(id))
    return response
  }

  postGallery(data) {
    const response = axios.post(API.product_gallery, data)
    return response
  }

  getGallery(id) {
    const response = axios.get(API.product_gallery_list(id))
    return response
  }

  getGalleryDetail(id) {
    const response = axios.get(API.product_gallery_edit(id))
    return response
  }

  putGalleryDetail(id, data) {
    const response = axios.put(API.product_gallery_edit(id), data)
    return response
  }

  deleteGalleryDetail(id) {
    const response = axios.delete(API.product_gallery_edit(id))
    return response
  }
}
const instance = new ProductService()
export default instance
